import React from 'react'
import styled from 'styled-components';
import Icon from '../../Icon';
import IconText from '../../MobileFooterMenu/IconText';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers';
import LoginModalTrigger from '../LoginModalTrigger';
import { breakpoint } from '../../../styling/mixins/breakpoints';

const StyledLoginIconLink = styled.div`
  cursor: pointer;
  ${breakpoint('large')} {
    padding: 1.6rem 0.8rem;
  }
  &:hover {
    opacity: 0.8;
  }
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
`

const StyledLoginIcon = styled(Icon)`
  font-size: 2rem;
  cursor: pointer;
`;

const LoginIconLink = () => {
  const myPage = useSelector((state: RootState) => state.pages.myPage);
  const userInfo = useSelector((state: RootState) => state.userInfo);
  const isAuthenticated = userInfo.current;

  return (
    <>
      {isAuthenticated ? (
        <a href={myPage.href} title={myPage.text} aria-label={myPage.text} className="hover:opacity-80">
          <StyledLoginIconLink className='flex items-center gap-1'>
            <StyledLoginIcon name='user' className="login__btn" />
            <IconText
              text={userInfo.current?.firstName ? userInfo.current?.firstName : undefined}
              translationKey={userInfo.current?.firstName ? undefined : 'general.profile-desktop'} >
            </IconText>
          </StyledLoginIconLink>
        </a>
      ) : (
        <LoginModalTrigger />
      )}
    </>
  )
}

export default LoginIconLink